import { CheckIcon } from '@itsrever/design-system'
import plansWithSections from '@/ui/components/rever-store/store-data/plansWithSections.json'

interface ComparisonTableProps {
  selectedPlan: number | undefined
  selectPlan: (index: number) => void
}
export const ComparisonTable: React.FC<ComparisonTableProps> = ({
  selectedPlan,
  selectPlan
}) => {
  const renderCellContent = (cellContent: unknown) => {
    if (typeof cellContent === 'string') {
      const cellContentArray = cellContent.split(':')
      return (
        <div className="flex flex-col">
          <p className="font-semiboldold text-sm">{cellContentArray[0]}</p>
          <p className="text-sm font-light">{cellContentArray[1]}</p>
        </div>
      )
    } else if (typeof cellContent === 'boolean') {
      return cellContent ? (
        <p className="scale-125">
          <CheckIcon />
        </p>
      ) : (
        <p className="text-gray-300">－</p>
      )
    }
  }

  return (
    <div className="mb-16 w-full">
      <div
        className="grid gap-1"
        style={{
          gridTemplateColumns: '1fr 230px 230px 230px'
        }}
      >
        <div></div>
        <p
          onClick={() => selectPlan(0)}
          className={
            'flex cursor-pointer items-center justify-center rounded-t-lg py-1 font-semibold transition-all hover:bg-stone-200 ' +
            (selectedPlan === 0 ? 'bg-stone-200' : 'bg-white')
          }
        >
          Smart
        </p>
        <p
          onClick={() => selectPlan(1)}
          className={
            'flex cursor-pointer items-center justify-center rounded-t-lg py-1 font-semibold transition-all hover:bg-slate-200 ' +
            (selectedPlan === 1 ? 'bg-slate-200' : 'bg-white')
          }
        >
          Premium
        </p>
        <p
          onClick={() => selectPlan(2)}
          className={
            'flex cursor-pointer items-center justify-center rounded-t-lg py-1 font-semibold transition-all hover:bg-yellow-200 ' +
            (selectedPlan === 2 ? 'bg-yellow-200' : 'bg-white')
          }
        >
          Professional
        </p>
      </div>
      <div className="flex flex-col gap-6">
        {plansWithSections.map((category, planIndex) => (
          <div key={planIndex + category.category}>
            <p className="mb-1 ml-4 text-base font-light text-gray-600">
              {category.category}
            </p>
            <div className="flex flex-col gap-1">
              {category.features.map((feature, featureIndex) => (
                <div
                  key={featureIndex + feature.name}
                  className="group grid content-center gap-1 rounded-lg bg-white hover:bg-gray-200"
                  style={{
                    gridTemplateColumns: '1fr 230px 230px 230px'
                  }}
                >
                  <div className="flex">
                    <div className="ml-4 flex items-center text-lg">
                      {feature.emoji}
                    </div>
                    <div className="flex flex-col justify-center rounded-l-lg px-4 py-2">
                      <p className="flex gap-2 text-sm font-bold">
                        {feature.name}
                      </p>
                      <p className="text-sm font-light">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                  <div
                    className={
                      'flex items-center justify-center ' +
                      (selectedPlan === 0
                        ? 'bg-stone-100 group-hover:bg-stone-200'
                        : '')
                    }
                  >
                    <div className="text-sm font-thin">
                      {renderCellContent(feature.values[0])}
                    </div>
                  </div>
                  <div
                    className={
                      'flex items-center justify-center ' +
                      (selectedPlan === 1
                        ? 'bg-slate-100 group-hover:bg-slate-200'
                        : '')
                    }
                  >
                    <div className="text-sm font-thin">
                      {renderCellContent(feature.values[1])}
                    </div>
                  </div>
                  <div
                    className={
                      'flex items-center justify-center ' +
                      (selectedPlan === 2
                        ? 'bg-yellow-100 group-hover:bg-yellow-200'
                        : '')
                    }
                  >
                    <div className="text-sm font-thin">
                      {renderCellContent(feature.values[2])}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
export default ComparisonTable
